import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ dark = false, testid = "newsletter-form" }) {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (website) { setDone(true); return; }
    try {
      await axios.post(`${API}/newsletter`, { email, website });
      setDone(true);
    } catch {
      setError(true);
    }
  };

  if (done) {
    return (
      <p data-testid={`${testid}-success`} className={`text-sm font-medium ${dark ? "text-[#D9C08A]" : "text-[#B08D3F]"}`}>
        Thank you. You are on the list.
      </p>
    );
  }

  return (
    <form onSubmit={submit} data-testid={testid} className="flex w-full max-w-md flex-col gap-3 sm:flex-row">
      <label htmlFor={`${testid}-email`} className="sr-only">Email address</label>
      <input
        id={`${testid}-email`}
        data-testid={`${testid}-email`}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        className={`flex-1 border px-4 py-3 text-sm outline-none transition-colors focus:border-[#B08D3F] ${
          dark
            ? "border-white/25 bg-white/10 text-white placeholder:text-white/50"
            : "border-[#D4D8E0] bg-white text-[#1A1A1A] placeholder:text-[#98A0B3]"
        }`}
      />
      <input
        type="text"
        name="website"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        className="absolute -left-[9999px] h-0 w-0 opacity-0"
      />
      <button
        type="submit"
        data-testid={`${testid}-submit`}
        className="bg-[#B08D3F] px-6 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors hover:bg-[#96772f]"
      >
        Subscribe
      </button>
      {error && <p className="text-sm text-red-400">Something went wrong. Please try again.</p>}
    </form>
  );
}
